// extracted by mini-css-extract-plugin
export default {"handle":"handle--SGVDC","handleResizing":"handleResizing--h6nhH","handleDisabled":"handleDisabled--GKG86"};